module.exports = __webpack_public_path__ + "static/media/ride_and_drive.dba036fd.png";